import React from 'react';

class Page404 extends React.Component {

    render() {
        return (
            <section className='home container' >
                <h2 className="section-title">Page not found</h2>
                <article className="not-found-article">
                   
                </article>
            </section>
        )
    }
}

export default Page404;